export function getTeamMemberUserId(member: any): string {
  if (!member) {
    return '';
  }
  if (member.user && member.user.id) {
    return member.user.id;
  }
  if (member.userMeta && member.userMeta.id) {
    return member.userMeta.id;
  }
  return member.userId || member.id || '';
}

export function getTeamMemberDisplayName(member: any): string {
  if (!member) {
    return 'Team member';
  }
  const name = (member.user && member.user.userMeta && member.user.userMeta.name)
    || (member.userMeta && member.userMeta.userMeta && member.userMeta.userMeta.name)
    || (member.user && member.user.email)
    || member.email;
  return name || 'Team member';
}

export function findTeamMemberByUserId(members: any[], userId: string): any {
  if (!userId || !members || !members.length) {
    return null;
  }
  return members.find((member) => getTeamMemberUserId(member) === userId) || null;
}
